module.exports = __webpack_public_path__ + "static/media/send.ed3ce441.svg";